import { render, staticRenderFns } from "./TOSCheckboxSelfAssessment.vue?vue&type=template&id=95fedf96&"
import script from "./TOSCheckboxSelfAssessment.vue?vue&type=script&lang=ts&"
export * from "./TOSCheckboxSelfAssessment.vue?vue&type=script&lang=ts&"
import style0 from "./TOSCheckboxSelfAssessment.vue?vue&type=style&index=0&id=95fedf96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports